// Package E — Orchestration ONLY. Never computes a quantity; passes
// the UI's own already-correct categories/summaryRows straight
// through to buildTakeoffReportPdfModel(), matching the exact
// architectural pattern already used elsewhere in CostSpace
// (exportCostControlPdf.js): build model -> render HTML -> open a
// print-ready window, opened synchronously before any await so
// browsers don't treat it as a blocked popup.
import { buildTakeoffReportPdfModel } from './buildTakeoffReportPdfModel'
import { renderTakeoffReportPdf } from './renderTakeoffReportPdf'

export function exportTakeoffReportPdf({ categories, summaryRows, tenderName, preparedBy }) {
  // Open the window synchronously — required so browsers treat this as
  // a direct result of the user's click, not a popup blocked async action.
  const win = window.open('', '_blank')
  if (!win) return // popup blocked — nothing we can silently work around; the caller's click already triggered this synchronously so this should not normally happen.

  const model = buildTakeoffReportPdfModel({ categories, summaryRows, tenderName, preparedBy })
  const html = renderTakeoffReportPdf(model)
  win.document.open()
  win.document.write(html)
  win.document.close()
  win.focus()
  // Give the new window a moment to finish laying out before invoking
  // the print dialog — matches the existing CostSpace Pro PDF pattern.
  setTimeout(() => win.print(), 300)
}
